// extracted by mini-css-extract-plugin
export default {"content":"RecommendedPackages_content__Lt6aP","pkgIcon":"RecommendedPackages_pkgIcon__DBHFQ"};